<main>
	<!-- EXISTING CONFIG (EDIT) -->
	<ng-container *ngIf="configKey && data != null">
		<h2>{{data.ConfigKey}}</h2>
		<p>Type: {{data.Metadata.Extension}}</p>
		<form #form>
			<textarea #configContent name="configContent" id="configContent" value="{{data.Content}}"></textarea>
		</form>
		<button (click)="postConfig()">Update</button>
		<h3>History:</h3>
		<!-- <p *ngIf="data.Archived.length == 0">No history to display</p> -->
		<ul class="history-list">
			<li class="title-row">
				<div>
					Updated On:
				</div>
				<div>
					Updated By:
				</div>
			</li>
			<li>
				<div>
					{{stringUtil.formatDateTime(data.Metadata.Timestamp)}} <em>(Current)</em>
				</div>
				<div>
					{{data.Metadata.Author}}
				</div>
			</li>
			<li *ngFor="let historyItem of data.Archived">
				<div>
					{{stringUtil.formatDateTime(historyItem.Metadata.Timestamp)}}
				</div>
				<div>
					{{historyItem.Metadata.Author}}
				</div>
			</li>
		</ul>
	</ng-container>

	<!-- NEW CONFIG (CREATE) -->
	<ng-container *ngIf="configKey == configDataService.RESERVED_NEW_CONFIG_KEY">
		<h2>Create Config</h2>
		<form #form>
			<div>
				<label for="configName">Config Name: </label>
				<input #configName name="configName" required />
			</div>
			<div>
				<label for="extension">Config Type (File Extension): </label>
				<input #extension name="extension" required />
			</div>
			<div>
				<label for="extension">Config Content: </label>
				<textarea #configContent name="configContent" id="configContent"></textarea>
			</div>
		</form>
		<button (click)="postConfig()">Create</button>
	</ng-container>
</main>